import { render } from "./RegulatoryBadge.vue?vue&type=template&id=670d6f9d&scoped=true"
import script from "./RegulatoryBadge.vue?vue&type=script&lang=js"
export * from "./RegulatoryBadge.vue?vue&type=script&lang=js"

import "./RegulatoryBadge.vue?vue&type=style&index=0&id=670d6f9d&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670d6f9d"]])

export default __exports__